module.exports = __webpack_public_path__ + "img/logo-header.bd2567cc.png";